import { render, staticRenderFns } from "./Organizacija.vue?vue&type=template&id=78c45805&"
import script from "./Organizacija.vue?vue&type=script&lang=js&"
export * from "./Organizacija.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports